import React from "react";
import { ViewLead } from "./ViewLeadShared";

/** Client detail view (`/clients/:id/view`). */
function ViewCustomer(props) {
  return <ViewLead {...props} type="client" />;
}

export default ViewCustomer;
